module.exports = __webpack_public_path__ + "img/yanbaologo.8982ad23.png";